<template>
  <div>
    <div class="sidebar">
      <b-nav pills vertical>
        <h3 v-if="isAdmin == '1'" @click="redirectAccueil"
          style="width: 100%; color: #fff; margin-top: 20px; text-align: center; margin-bottom: 20px; font-size: large; cursor: pointer;">
          Administrateur Aloha</h3>
        <h3 v-if="isAdmin == '0'" @click="redirectUserPage"
          style="width: 100%; color: #fff; margin-top: 20px; text-align: center; margin-bottom: 20px; font-size: large; cursor: pointer;">
          Utilisateur Aloha</h3>
        <b-nav-item v-if="isAdmin == '1'" class="nav-item" to="/indexAdmin" :active="isActive('/indexAdmin')"><i
            class="fas fa-th-large"></i>
          Tableau de bord</b-nav-item>
        <b-nav-item v-if="isAdmin == '1'" class="nav-item" to="/feuilles-de-temps"
          :active="isActive('/feuilles-de-temps')"><i class="far fa-clock"></i> Feuilles de temps</b-nav-item>
        <b-nav-item class="nav-item" to="/agenda" :active="isActive('/agenda')"><i class="fas fa-calendar-alt"></i>
          Agenda</b-nav-item>
        <b-nav-item v-if="isAdmin == '1'" class="nav-item" to="/settings" :active="isActive('/settings')"><i
            class="fas fa-cog"></i>
          Paramètres</b-nav-item>
        <b-nav-item class="nav-item" v-on:click="disconnect()"><i class="fas fa-sign-out-alt"></i>
          Déconnexion</b-nav-item>
        <b-nav-item v-if="isAdmin == '1'" class="nav-item" v-on:click="changeCompany()"><i
            class="fas fa-sign-out-alt"></i>
          Changer entreprise</b-nav-item>
      </b-nav>
    </div>

  </div>
</template>
<script>
import script from '../../script/script.js';
import script_pointage from '../../script/script_pointage.js';


var moment = require('moment');
function initValue() {
  return {
    active: true,
    time: moment().format('LLLL'),
    intervalTime: null,
    form: {
      type_actu: '1',
      panneau: '1',
      interne: '2',
      titre: '',
      description: '',
      location: '',
      dateDebut: moment().valueOf(),
      dateFin: moment().valueOf(),
      images: [],
    },
    formAssociation: {
      name: '',
      address: '',
      zip: '',
      town: '',
      email: '',
      tel: '',
      fax: '',
    },
    formArtisan: {
      firstname: '',
      lastname: '',
      address: '',
      zip: '',
      town: '',
      email: '',
      tel: '',
      fax: '',
    },
    fileList: [],
    isAdmin: localStorage.getItem('admin')
  }
}
export default {
  data() {
    return initValue()
  },
  beforeCreate() {
    moment.locale('fr');
  },
  mounted() {
    this.loadingInfo();
    this.intervalTime = setInterval(() => this.time = moment().format('LLLL'), 500);
  },
  beforeDestroy() {
    clearInterval(this.intervalTime);
  },
  methods: {
    disconnect: script.disconnect,
    changeCompany: script.changeCompany,
    loadingInfo: script.loadingInfo,
    addEvent: script_pointage.addEvent,
    addAssociation: script_pointage.addAssociation,
    addArtisan: script_pointage.addArtisan,


    isActive(route) {
      return this.$route.path === route;
    },

    resetModalAjoutEvents() {
      Object.assign(this.$data, initValue())
      this.$refs.modalAjoutEvents.hide()
    },
    resetModalAjoutArtisan() {
      Object.assign(this.$data, initValue())
      this.$refs.modalAjoutArtisan.hide()
    },
    resetModalAjoutAssociations() {
      Object.assign(this.$data, initValue())
      this.$refs.modalAjoutAssociation.hide()
    },
    redirectAccueil() {
      this.$router.push({ path: '/indexAdmin' })
    },
    redirectUserPage(){
      this.$router.push({path: "/feuilles-de-temps/"+localStorage.getItem('userid')})
    },
    redirectInfosInterne() {
      this.$router.push({ path: '/infos-interne' })
    },
    confirm() {
      if (!this.form.titre || !this.form.dateDebut || !this.form.dateFin || !this.form.location) {
        this.toasterError('Tous les champs doivent être remplis', 'Erreur dans les champs saisis')
      } else {
        this.addEvent(this.form.location, this.convertToMilliseconds(this.form.dateDebut), this.convertToMilliseconds(this.form.dateFin), this.form.titre, this.form.description, this.form.type_actu, this.form.panneau, this.form.interne).then(script_pointage.initComponent)
      }
    },
    confirmArtisan() {
      if (!this.formArtisan.firstname || !this.formArtisan.lastname || !this.formArtisan.address || !this.formArtisan.zip || !this.formArtisan.town || !this.formArtisan.email || !this.formArtisan.tel) {
        console.log(this.formArtisan.firstname, this.formArtisan.lastname, this.formArtisan.address, this.formArtisan.zip, this.formArtisan.town, this.formArtisan.email, this.formArtisan.tel)
        this.toasterError('Tous les champs doivent être remplis', 'Erreur dans les champs saisis')
      } else {
        console.log(this.formArtisan.name, this.formArtisan.address, this.formArtisan.zip, this.formArtisan.town, localStorage.getItem('socid'), this.formArtisan.email, this.formArtisan.tel)
        this.addArtisan(this.formArtisan.firstname, this.formArtisan.lastname, this.formArtisan.address, this.formArtisan.zip, this.formArtisan.town, localStorage.getItem('socid'), this.formArtisan.tel, this.formArtisan.email, this.formArtisan.fax).then(this.resetModalAjoutArtisan());
        this.toasterSuccess('association créée avec succès', 'Succès !')
      }
    },
    confirmAssociation() {
      if (!this.formAssociation.name || !this.formAssociation.address || !this.formAssociation.zip || !this.formAssociation.town || !this.formAssociation.email || !this.formAssociation.tel) {
        console.log(this.formAssociation.name, this.formAssociation.address, this.formAssociation.zip, this.formAssociation.town, this.formAssociation.email, this.formAssociation.tel)
        this.toasterError('Tous les champs doivent être remplis', 'Erreur dans les champs saisis')
      } else {
        console.log(this.formAssociation.name, this.formAssociation.address, this.formAssociation.zip, this.formAssociation.town, localStorage.getItem('socid'), this.formAssociation.email, this.formAssociation.tel)
        this.addAssociation(this.formAssociation.name, this.formAssociation.address, this.formAssociation.zip, this.formAssociation.town, localStorage.getItem('socid'), this.formAssociation.tel, this.formAssociation.email, this.formAssociation.fax).then(this.resetModalAjoutArtisan());
        this.toasterSuccess('Artisan créé avec succès', 'Succès !')
      }
    },
    convertToMilliseconds(dateString) {
      const selectedDate = new Date(dateString);
      return selectedDate.getTime() / 1000;
    },
    changeInterne() {
      if (this.form.interne == '1') {
        this.form.panneau = '2'
      }
    },

    changePanneau() {
      this.form.interne = '2'
    },
    handlePreview(file) {
      console.log('preview', file);
    },
    handleRemove(file) {
      console.log('remove file', file);
    },
    handleChange(file, fileList) {
      this.fileList = fileList;
    },
    toasterError: script.toasterError,
    toasterSuccess: script.toasterSuccess,
  },
  computed: {
    info() {
      return this.$store.state.info
    }
  }

}
</script>

<style>
#navbar .btn-secondary,
#navbar .btn-secondary:hover,
#navbar .btn-secondary:active,
#navbar .btn-secondary:focus,
#navbar .btn-secondary:not(:disabled):not(.disabled).active,
#navbar .btn-secondary:not(:disabled):not(.disabled):active,
#navbar .show>.btn-secondary.dropdown-toggle {
  background-color: transparent;
  border-color: transparent;
  box-shadow: none;
}

.nav-item.nav-item.nav-item a {
  color: #fff;
}

.nav-item {
  width: 100%;
  margin-top: 5px;
  margin-bottom: 5px;
}

.sidebar {
  height: 100vh;
  width: 200px;
  background-color: #333;
  border-right: 0.1px solid #909090;
}

.sidebar .navbar-nav {
  width: 100%;
}

.sidebar .navbar-nav .nav-item {
  display: flex;
  align-items: center;
  width: 100%;
}

.sidebar .navbar-nav .nav-link {
  text-align: center;
}

.sidebar .navbar-nav .dropdown-menu {
  width: auto;
}

.dropdown:before,
.dropdown.active:before {
  content: '';
}

.button-icons {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.fas.fa-bullhorn,
.fas.fa-home,
.fas.fa-building {
  height: 33px;
}
</style>

<style scoped>
.fas.fa-bullhorn,
.fas.fa-home,
.fas.fa-building {
  height: 33px;
}
</style>
